import {
  Box,
  Button,
  FormLabel,
  Heading,
  HStack,
  Icon,
  Input,
  SimpleGrid,
  Stack,
  Switch,
  Text,
  Textarea,
  Tooltip,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { MdInfoOutline } from "react-icons/md";
import ReactQuill from "react-quill";
import MathQuill4Quill from 'mathquill4quill';
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import { getAllChaptersRequest } from "../../../../modules/admin-modules/chapters/Actions";
import { editExamQuestionRequest } from "../../../../modules/admin-modules/exams/Actions";
import { closeCreateQuestionModel } from "../../../../modules/admin-modules/models/Actions";
import {
  createQuestionBankRequest,
  editQuestionBankRequest,
} from "../../../../modules/admin-modules/questions-bank/Actions";
import { getAllTagsRequest } from "../../../../modules/admin-modules/tags/Actions";

import "react-quill/dist/quill.snow.css";
import katex from 'katex';
import 'katex/dist/katex.min.css';

const LabelWithHint = ({ children, hint }) => (
  <HStack spacing="6px" mb="2" alignItems="center">
    <FormLabel mb="0">{children}</FormLabel>
    {hint && (
      <Tooltip
        label={hint}
        hasArrow
        placement="top"
        bg="gray.700"
        color="white"
        borderRadius="8px"
        px="3"
        py="2"
        fontSize="sm"
        maxW="280px"
        textAlign="right"
      >
        <Box as="span" display="inline-flex" cursor="help" color="gray.500">
          <Icon as={MdInfoOutline} boxSize="18px" />
        </Box>
      </Tooltip>
    )}
  </HStack>
);

const SettingCard = ({ title, children }) => (
  <Box
    w="100%"
    bg="#fafafa"
    border="1px solid"
    borderColor="gray.200"
    borderRadius="16px"
    p="20px"
  >
    {title && (
      <Text fontWeight="600" color="main_1" mb="16px" fontSize="16px">
        {title}
      </Text>
    )}
    {children}
  </Box>
);

const AddQuestion = ({ isAdd, data, setSelectedData }) => {
  const baseUrl = "https://asquera.com/asquera";

  const dispatch = useDispatch();

  const [selected, setSelected] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  const [questionAnswerImg, setQuestionAnswerImg] = useState("");

  const [answers, setAnswers] = useState([]);
  const [rightAnswer, setRightAnwser] = useState();

  const [isTrueOrFalse, setIsTrueOrFalse] = useState(false);

  const openQuestions = useSelector((state) => state.model.isOpen16);
  const chapters = useSelector((state) => state.chapters.chapters);
  const tags = useSelector((state) => state.adminTags.tags);
  const isLoading = useSelector((state) => state.questionsBank.isLoading);
  useEffect(() => {
    if (openQuestions) {
      dispatch(getAllChaptersRequest({ active: 0 }));
      dispatch(getAllTagsRequest());
    }
  }, [openQuestions]);

  useEffect(() => {
    if (!isAdd) {
      setAnswers(data?.answers ?? []);
      const filter = data?.answers
        ?.map((data, index) => {
          if (data?.right_answer == 1) return index;
        })
        .filter((data) => data != undefined);
      if (filter?.length > 0) {
        setRightAnwser(filter[0]);
      }
    } else if (isAdd) {
      setAnswers([]);
      setRightAnwser(null);
      setSelectedTags([]);
    }
  }, [isAdd, data]);
  const chaptersOptions = chapters
    ?.filter((data) => Number(data.active) === 0)
    ?.map((data) => {
      return { value: data.id, label: data.name };
    });

  const tagsOptions = tags?.map((data) => {
    return { value: data.id, label: data.name };
  })

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: !isAdd ? data : { difficulty_level: "1", mark: 1 },
    shouldUnregister: true,
  });

  // Set tags when editing (must run after useForm so setValue is available)
  useEffect(() => {
    if (!isAdd && data?.tags) {
      const tagOptions = data.tags.map((t) => ({ value: t.id, label: t.name }));
      setSelectedTags(tagOptions);
      tagOptions.forEach((tag, idx) => setValue(`tags[${idx}]`, tag.value));
      const maxTags = 10;
      for (let i = tagOptions.length; i < maxTags; i++) {
        setValue(`tags[${i}]`, undefined);
      }
    }
  }, [isAdd, data, setValue]);

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة سؤال" : "تعديل  سؤال"}
      </Heading>
    </Box>
  );

  const onSubmit = async (val) => {
    const values = {
      ...val,
      difficulty_level: val?.difficulty_level ? val?.difficulty_level : "0",
    };
    const action = () => {
      dispatch(closeCreateQuestionModel());
      setSelectedData({});
      reset();
      setAnswers([]);
    };

    if (isAdd) {
      let formData = await new FormData();
      
      // Handle all form values except tags
      for (let key in values) {
        if (key !== 'tags') {
          if (key === 'url' && (values[key] == null || values[key] === '')) continue;
          formData.append(key, values[key]);
        }
      }
      
      // Handle tags: send only defined tag ids; when empty, omit tags so backend doesn't insert
      const tagIds = Object.values(values.tags || {}).filter(
        (v) => v !== undefined && v !== ''
      );
      if (tagIds.length > 0) {
        tagIds.forEach((id, idx) => formData.append(`tags[${idx}]`, id));
      }

      answers.map((data, idx) =>
        formData.append(`answers[${idx}][answer]`, data?.answer)
      );
      answers.map((data, idx) =>
        formData.append(
          `answers[${idx}][right_answer]`,
          data?.right_answer ? data?.right_answer : 0
        )
      );
      const filteredAnswers = answers?.filter(
        (data, idx) => data?.right_answer == 1
      );

      console.log(answers);
      console.log(filteredAnswers);

      if (values.chapter_id && (answers?.length == 4 || answers?.length == 2)) {
        if (filteredAnswers?.length > 0)
          await dispatch(createQuestionBankRequest(formData, action));
        else toast.error("اختر اجابة صحيحة ");
      } else {
        toast.error("  قم بمراجعة الاجابات او  اختر الفصل ");
      }
    } else {
      let formData = await new FormData();
      const keys = [
        "select",
        "answers",
        "index",
        "delete",
        "edit",
        "chapter",
        "bookmark",
        "Actions",
        "deleted_at",

      ];
      formData.append("_method", "PUT");

      const totel = { ...data, ...values };
      answers.map((data, idx) =>
        formData.append(`answers[${idx}][id]`, data?.id)
      );



      answers.map((data, idx) =>
        formData.append(`answers[${idx}][answer]`, data?.answer)
      );
      answers.map((data, idx) =>
        formData.append(`answers[${idx}][right_answer]`, data?.right_answer)
      );

      for (let key in totel) {
        if (!keys.includes(key) && key !== 'tags') {
          if (key === 'url' && (totel[key] == null || totel[key] === '')) continue;
          formData.append(key, totel[key]);
        }
      }
      // Handle tags from form: send only defined tag ids; when empty, omit so backend can clear pivots
      const editTagIds = Object.values(values.tags || {}).filter(
        (v) => v !== undefined && v !== ''
      );
      if (editTagIds.length > 0) {
        editTagIds.forEach((id, idx) => formData.append(`tags[${idx}]`, id));
      }
      dispatch(
        editQuestionBankRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
    }
  };
  const closeFunc = () => {
    dispatch(closeCreateQuestionModel());
    setSelectedData({});
    setAnswers([]);
    reset();
  };
  const handelEditQuestion = (answerID, index) => {
    //console.log(answerID);
    //console.log(answers[index]);
    let formData = new FormData();
    formData.append("_method", "PUT");
    formData.append("question_id", data?.id);
    formData.append("right_answer", answers[index]?.right_answer);
    formData.append("answer", answers[index]?.answer);
    dispatch(
      editExamQuestionRequest({
        formData: formData,
        id: answerID,
      })
    );
  };
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],
    ['formula'],
  
    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    [{ 'direction': 'rtl' }],                         // text direction
  
    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  
    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    [{ 'align': [] }],
  
    ['clean']                                         // remove formatting button
  ];

  const quillRef = useRef(null);

useEffect(() => {
  if (quillRef.current) {
    // Initialize MathQuill after the component mounts
    const enableMathQuillFormulaAuthoring = MathQuill4Quill({ Quill: ReactQuill.Quill, katex: window.katex });
    enableMathQuillFormulaAuthoring(quillRef.current.getEditor(), {
      operators: [
        ["\\sqrt{x}", "\\sqrt"],
        ["\\sqrt[n]{x}", "\\nthroot"],
        ["x^2", "^"],
        ["x_n", "_"],
        ["\\frac{x}{y}", "\\frac"],
        ["\\int_a^b", "\\int"],
        ["\\sum_{i=0}^n", "\\sum"],
      ]
    });
  }
}, [quillRef]);

// Make katex available globally for Quill
window.katex = katex;

// Register formula module if needed
if (ReactQuill.Quill) {
const Quill = ReactQuill.Quill;

// Only register if not already registered
if (!Quill.imports['formats/formula']) {
const Formula = Quill.import('formats/formula');
Quill.register(Formula, true);
}
}
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openQuestions}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <VStack w="100%" spacing="24px" alignItems="stretch" dir="rtl">
          <SettingCard title="نص السؤال">
            <Box mb="16px">
              <LabelWithHint hint="نص اختياري يظهر قبل السؤال (مثل قطعة قراءة أو فقرة)">
                نص القطعة:
              </LabelWithHint>
              <Textarea
                name="comprehension"
                placeholder="ادخل نص القطعة التي تسبق السؤال"
                defaultValue={data?.comprehension}
                error={errors?.comprehension?.message}
                {...register("comprehension")}
                bg="white"
                borderRadius="12px"
              />
            </Box>
            <Box>
              <LabelWithHint hint="نص السؤال الأساسي. يمكنك إضافة معادلات وصيغ رياضية من شريط الأدوات">
                نص السؤال
              </LabelWithHint>
              <ReactQuill
                theme="snow"
                register={register}
                name="question"
                defaultValue={data?.question}
                onChange={(val) => setValue("question", val)}
                modules={{
                  toolbar: toolbarOptions,
                  formula: true,
                }}
              />
            </Box>
          </SettingCard>

          <SettingCard title="درجة السؤال">
            <Box maxW={{ base: "100%", md: "50%" }}>
              <LabelWithHint hint="درجة هذا السؤال عند ظهوره في الاختبار">
                درجة السؤال
              </LabelWithHint>
              <MainInput
                label=""
                defaultValues={data?.mark || 1}
                error={errors?.mark?.message}
                placeholder="ادخل درجة السؤال"
                register={register}
                name="mark"
                type="number"
                required={false}
              />
            </Box>
          </SettingCard>

          <SettingCard title="الصور و هينت الفيديو">
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing="20px" w="100%" mb="20px">
              <Box>
                <LabelWithHint hint="صورة اختيارية تظهر مع نص السؤال للطالب">
                  صورة السؤال:
                </LabelWithHint>
                <HStack spacing="12px" alignItems="center" flexWrap="wrap">
                  <Button
                    bg="main_1"
                    color="white"
                    borderRadius="8px"
                    textAlign="center"
                    position="relative"
                  >
                    <Text>
                      {selected
                        ? selected
                        : data?.image
                          ? `file_1`
                          : "اختر ملف ليتم رفعه"}
                    </Text>
                    <Input
                      onChange={(e) => {
                        setValue("image", e.target.files[0]);
                        setSelected((s) => e.target.files[0].name);
                      }}
                      type="file"
                      placeholder="اختر ملف ليتم رفعه"
                      opacity="0"
                      position="absolute"
                      w="100%"
                      h="100%"
                    />
                  </Button>
                  {data?.image && (
                    <img src={`${baseUrl}/${data?.image}`} width="120px" alt="question" />
                  )}
                </HStack>
              </Box>

              <Box>
                <LabelWithHint hint="صورة نموذج الإجابة الصحيحة (للمراجعة أو التصحيح)">
                  صورة اجابة السؤال:
                </LabelWithHint>
                <HStack spacing="12px" alignItems="center" flexWrap="wrap">
                  <Button
                    bg="main_1"
                    color="white"
                    borderRadius="8px"
                    textAlign="center"
                    position="relative"
                  >
                    <Text>
                      {questionAnswerImg
                        ? questionAnswerImg
                        : data?.model_answer_image
                          ? `file_1`
                          : "اختر ملف ليتم رفعه"}
                    </Text>
                    <Input
                      onChange={(e) => {
                        setValue("model_answer_image", e.target.files[0]);
                        setQuestionAnswerImg((s) => e.target.files[0].name);
                      }}
                      type="file"
                      placeholder="اختر ملف ليتم رفعه"
                      opacity="0"
                      position="absolute"
                      w="100%"
                      h="100%"
                    />
                  </Button>
                  {data?.model_answer_image && (
                    <img
                      src={`${baseUrl}/${data?.model_answer_image}`}
                      width="120px"
                      alt="answer"
                    />
                  )}
                </HStack>
              </Box>
            </SimpleGrid>

            <Box maxW={{ base: "100%", md: "50%" }}>
              <LabelWithHint hint="رابط فيديو يوتيوب يظهر كتلميح (hint) لمساعدة الطالب على فهم السؤال">
                رابط هينت الفيديو (يوتيوب)
              </LabelWithHint>
              <MainInput
                label=""
                defaultValues={data?.url}
                error={errors?.url?.message}
                placeholder="الصق رابط يوتيوب هنا"
                register={register}
                name="url"
                type="url"
                required={false}
              />
            </Box>
          </SettingCard>

          <SettingCard title="التصنيف والحافظة">
            <Box mb="20px">
              <LabelWithHint hint="حدد مستوى صعوبة السؤال لتصنيفه داخل بنك الأسئلة">
                مستوي السؤال :
              </LabelWithHint>
              <Stack direction="row" spacing="20px" flexWrap="wrap">
                <label>
                  <input
                    {...register("difficulty_level")}
                    type="radio"
                    value="1"
                    defaultChecked={data?.difficulty_level == 1 ? true : false}
                  />
                  {" "}notes
                </label>
                <label>
                  <input
                    {...register("difficulty_level")}
                    type="radio"
                    value="2"
                    defaultChecked={data?.difficulty_level == 2 ? true : false}
                  />
                  {" "}كتاب المدرسة
                </label>
                <label>
                  <input
                    {...register("difficulty_level")}
                    type="radio"
                    value="3"
                    defaultChecked={data?.difficulty_level == 3 ? true : false}
                  />
                  {" "}hard questions
                </label>
                <label>
                  <input
                    {...register("difficulty_level")}
                    type="radio"
                    value="4"
                    defaultChecked={data?.difficulty_level == 4 ? true : false}
                  />
                  {" "}امتحانات السنين السابقة
                </label>
                <label>
                  <input
                    {...register("difficulty_level")}
                    type="radio"
                    value="5"
                    defaultChecked={data?.difficulty_level == 5 ? true : false}
                  />
                  {" "}Revision
                </label>
              </Stack>
            </Box>

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing="20px" w="100%">
              <Box>
                <LabelWithHint hint="حافظة الاسئلة التي سيُحفظ فيها هذا السؤال (مصدر سحب الأسئلة للاختبارات)">
                  حافظة الاسئلة :
                </LabelWithHint>
                <Select
                  options={chaptersOptions}
                  onChange={(data) => setValue("chapter_id", data.value)}
                  styles={colourStyles}
                  placeholder="اختر حافظة الاسئلة"
                  defaultValue={{
                    label: data?.chapter?.name,
                    value: data?.chapter?.id,
                  }}
                />
              </Box>

              <Box>
                <LabelWithHint hint="علامات لتصفية وتنظيم الأسئلة داخل البنك">
                  العلامات Tags :
                </LabelWithHint>
                <Select
                  options={tagsOptions}
                  isMulti={true}
                  value={selectedTags}
                  onChange={(data) => {
                    setSelectedTags(data || []);
                    const maxTags = 10;
                    for (let i = 0; i < maxTags; i++) {
                      setValue(`tags[${i}]`, undefined);
                    }
                    (data || []).forEach((tag, idx) => {
                      setValue(`tags[${idx}]`, tag.value);
                    });
                  }}
                  styles={colourStyles}
                  placeholder="Tags"
                />
              </Box>
            </SimpleGrid>
          </SettingCard>

          <SettingCard title="الاجابات">
            <HStack mb="16px" spacing="10px">
              <LabelWithHint hint="فعّل هذا الخيار إذا كان السؤال صح أو خطأ (إجابتان فقط بدل أربع)">
                True or False
              </LabelWithHint>
              <input
                type="checkbox"
                onChange={(e) => setIsTrueOrFalse(e.target.checked)}
                defaultChecked={isTrueOrFalse}
              />
            </HStack>

            <Text fontSize="13px" color="gray.600" mb="12px">
              اكتب الإجابات ثم فعّل المفتاح بجانب الإجابة الصحيحة
            </Text>

            {[...Array(isTrueOrFalse ? 2 : 4)].map((val, index) => {
              return (
                <HStack my="10px" key={index}>
                  <Input
                    defaultValue={
                      data?.answers?.length > 0 && !isAdd
                        ? data?.answers[index]?.answer
                        : null
                    }
                    placeholder={`الإجابة ${index + 1}`}
                    size="md"
                    bg="white"
                    borderRadius="12px"
                    onChange={(e) => {
                      const newAnswers = answers;
                      newAnswers[index] = {
                        ...newAnswers[index],
                        answer: e.target.value,
                      };
                      setAnswers(newAnswers);
                    }}
                  />

                  <Switch
                    size="lg"
                    isChecked={rightAnswer == index ? true : false}
                    color="#010038"
                    onChange={(e) => {
                      setRightAnwser(index);
                      let newAnswers = answers;
                      let mappedData = newAnswers?.map((val, idx) => {
                        return { ...val, right_answer: idx == index ? 1 : 0 };
                      });
                      setAnswers(mappedData);
                    }}
                  />
                </HStack>
              );
            })}
          </SettingCard>
        </VStack>
      </form>
    </MainModel>
  );
};

export default AddQuestion;


